import cookie from 'js-cookie'

const STORAGE_TYPE_COOKIE = 'cookie'
const STORAGE_TYPE_LOCALSTORAGE = 'localStorage'

let storage = {}

let save_type = STORAGE_TYPE_LOCALSTORAGE
if (typeof localStorage === 'object') {
  try {
    localStorage.setItem('localStorageTest', 1)
    localStorage.removeItem('localStorageTest')
  } catch (e) {
    save_type = STORAGE_TYPE_COOKIE
  }
}

// save_type = STORAGE_TYPE_COOKIE


storage.localStorage = save_type === STORAGE_TYPE_LOCALSTORAGE

storage.set = function (key, val) {
  key = process.env.NODE_ENV + "_" +
        process.env.VUE_APP_NAME + "_" +
        key;
  switch(save_type){
    case STORAGE_TYPE_LOCALSTORAGE:
      localStorage.setItem(key, val)
      break
    case STORAGE_TYPE_COOKIE:
      cookie.set(key,val, { expires: 3650, domain:this.getDomain()})
      // cookie.set(key,val, { expires: 3650, domain:'firefox'})
      break
  }
}

storage.getDomain = function () {
  let host = window.location.host;
  if(!this.isIp(host)){
    let topDomain = host.match(/[\w-]+\.[\w]{2,3}$/g);
    topDomain && (host = topDomain[0]);
  }
  return host
}
storage.isIp = function (host) {
  return /\b(?:(?:2(?:[0-4][0-9]|5[0-5])|[0-1]?[0-9]?[0-9])\.){3}(?:(?:2([0-4][0-9]|5[0-5])|[0-1]?[0-9]?[0-9]))\b/.test(host)
}

storage.get = function (key) {
  key = process.env.NODE_ENV + "_" +
        process.env.VUE_APP_NAME + "_" +
        key;
  let val = ''
  switch(save_type){
    case STORAGE_TYPE_LOCALSTORAGE:
      val = localStorage.getItem(key)
      break
    case STORAGE_TYPE_COOKIE:
      val = cookie.get(key)
  }
  return val
}

export default storage



// WEBPACK FOOTER //
// ./src/models/storage.js